import React, { useCallback } from 'react'
import { Popconfirm, message, Button } from 'antd'
import { useSelector } from 'react-redux'
import * as apis from '@/apis'
import * as userSelector from '@/models/user/selectors'

const tenantMode = process.env.APP_MODE === 'tenant'

export default function CallNumber(props) {
  const isTour = useSelector(userSelector.isTour)
  const callNumber = useCallback(() => {
    apis.callNumber({ callee: props.number })
      .then(() => {
        message.success('已执行，请注意接听')
      })
      .catch(error => {
        message.error(error.message || '调用异常')
      })
  }, [props])

  if (tenantMode) {
    return props.number || null
  }

  if (!props.number) {
    return <span>-</span>
  }

  const show = isTour || props.show

  return (
    <Popconfirm
      title="确定要拨号?"
      onConfirm={callNumber}
      okText="确定"
      cancelText="取消">
      <Button type="link" icon="phone" size={props.size ? props.size : "small"}>
        {show ? props.number : props.number.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}
      </Button>
      {/* <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
        <span style={{ marginRight: 2, color: '#5ac128', fontSize: '1.4rem' }} className="iconfont">&#xe6c2;</span>
        {show ? props.number : props.number.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}
      </div> */}
    </Popconfirm>
  )
}
